export default {
  data() {
    return {
      inputType: 'radio',
      inputTypeDef: {}
    }
  },
  methods: {

  }
}
